<template>
  <div v-if="isVisible" class="popup-overlay">
    <div class="popup-content">
      <h3>Mancano alcuni dati</h3>
      <p>Completa i dati richiesti per il tuo profilo</p>
      <form @submit.prevent="handleSubmit">
        <div class="container">
          <div class="row">
            <div class="form-group col-sm-6">
              <label>Nome</label>
              <input
                type="text"
                v-model="formData.name"
                required
                class="form-control"
              />
            </div>
            <div class="form-group col-sm-6">
              <label>Cognome</label>
              <input
                type="text"
                v-model="formData.surname"
                required
                class="form-control"
              />
            </div>
          </div>
          <div class="row">
            <div class="form-group col-sm-6">
              <label>Indirizzo</label>
              <input
                type="text"
                v-model="formData.address"
                required
                class="form-control"
              />
            </div>
            <div class="form-group col-sm-6">
              <label>CAP</label>
              <input
                type="text"
                v-model="formData.cap"
                required
                class="form-control"
              />
            </div>
          </div>
          <div class="row">
            <div class="form-group col-sm-6">
              <label>Città</label>
              <input
                type="text"
                v-model="formData.city"
                required
                class="form-control"
              />
            </div>
            <div class="form-group col-sm-6">
              <label>Provincia</label>
              <input
                type="text"
                v-model="formData.province"
                required
                class="form-control"
              />
            </div>
          </div>
          <div class="row">
            <div class="form-group col-sm-6">
              <label>Codice fiscale</label>
              <input
                type="text"
                v-model="formData.fiscalCode"
                minlength="16"
                required
                class="form-control"
              />
            </div>
            <div class="form-group col-sm-6">
              <label>Numero di telefono</label>
              <input
                type="text"
                v-model="formData.phone"
                required
                class="form-control"
              />
            </div>
          </div>
          <div class="btn-actions">
            <input type="submit" class="btn btn-dark pl-50 pr-50 bg-theme-colored text-white" value="Aggiorna" />
            <input type="button" class="btn btn-dark pl-50 pr-50 text-white" value="Chiudi" @click="closePopup" />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
  
  <script>
export default {
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    extFormData: {
      type: Object,
      required: true,
    },
  },
  watch: {
    extFormData: {
      handler(newValue) {
        this.formData.name = newValue.Name;
        this.formData.surname = newValue.Surname;
        this.formData.address = newValue.Address;
        this.formData.cap = newValue.CAP;
        this.formData.city = newValue.City;
        this.formData.province = newValue.Province;
        this.formData.fiscalCode = newValue.FiscalCode;
        this.formData.phone = newValue.Phone;
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      formData: {
        name: "",
        surname: "",
        address: "",
        cap: "",
        city: "",
        province: "",
        fiscalCode: "",
        phone: "",
      },
    };
  },
  methods: {
    handleSubmit() {
      // Emitti un evento con i dati del form al componente padre
      this.$emit("submit", this.formData);

      this.closePopup();
    },
    closePopup() {
      this.$emit("close");
    },
  },
};
</script>
  
  <style>
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;

  z-index: 20;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto; /* Consenti lo scorrimento dell'intero overlay */
}

.popup-content {
  background: white;
  padding: 20px;
  text-align: center;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  max-height: 70vh; /* Limita l'altezza del popup */
  overflow-y: auto; /* Consenti lo scorrimento verticale */
  width: 90%; /* Assicura che il popup sia reattivo */
}

.btn-actions{
    display: flex;
    justify-content: space-evenly;
  margin-top: 20px;
}
</style>